import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'

import {isEmpty, toSentence} from '../../../lib/tools'

/**
 * The state nobody expects: a contact accepted, but the job that seals their piece to them needed
 * the session that sent the invite and that session was already gone. Nothing on the user's side
 * looks wrong, so this has to announce itself on arrival rather than wait to be found.
 *
 * The copy never mentions jobs, sessions or wrapping. "Can't hold their piece yet" is true and sits
 * in the vocabulary the slots graphic already taught.
 */
const PendingShares = props => {
  if (props.retry) {
    return (
      <Alert className='pending-shares' severity='info'>
        <AlertTitle>Not quite ready</AlertTitle>
        Your session is still getting set up. Wait a few seconds and try again.
      </Alert>
    )
  }

  if (props.wrapped > 0) {
    return (
      <Alert className='pending-shares' severity='success'>
        <AlertTitle>All set</AlertTitle>
        {props.wrapped === 1 ? 'One piece handed over.' : `${props.wrapped} pieces handed over.`} Your
        contacts can hold their pieces now.
      </Alert>
    )
  }

  if (isEmpty(props.pendingWraps))
    return null

  const names = toSentence(props.pendingWraps.map(invite => invite.firstName))
  const several = props.pendingWraps.length > 1

  return (
    <Alert
      className='pending-shares'
      severity='warning'
      action={
        <Button
          disabled={props.loading}
          onClick={props.onFinish}
          size='small'
          sx={{whiteSpace: 'nowrap'}}>
          Finish setting up
        </Button>
      }>
      <AlertTitle>{names} can't hold their {several ? 'pieces' : 'piece'} yet</AlertTitle>
      {several ? "They accepted, but their pieces weren't" : "They accepted, but their piece wasn't"} handed
      over — this can happen if you signed out soon after inviting them. Finishing takes a moment and
      only you can do it.
    </Alert>
  )
}

PendingShares.propTypes = {
  pendingWraps: PropTypes.array,
  onFinish: PropTypes.func.isRequired,
  retry: PropTypes.bool,
  wrapped: PropTypes.number,
  loading: PropTypes.bool
}

export default PendingShares
